import { getExtHostServices } from './extHost.js';
function create(getExtension) {
    return {
        t(...params) {
            const { extHostLocalization } = getExtHostServices();
            const extension = getExtension();
            if (typeof params[0] === 'string') {
                const key = params.shift();
                const argsFormatted = !params || typeof params[0] !== 'object' ? params : params[0];
                return extHostLocalization.getMessage(extension.identifier.value, { message: key, args: argsFormatted });
            }
            return extHostLocalization.getMessage(extension.identifier.value, params[0]);
        },
        get bundle() {
            const { extHostLocalization } = getExtHostServices();
            const extension = getExtension();
            return extHostLocalization.getBundle(extension.identifier.value);
        },
        get uri() {
            const { extHostLocalization } = getExtHostServices();
            const extension = getExtension();
            return extHostLocalization.getBundleUri(extension.identifier.value);
        }
    };
}
export { create as default };
